(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["legacy-home-banner"] && !Shopify.designMode) return;
  try {
    
  const syncLegacyHomeSidebar = () => {
    document.querySelectorAll('[data-legacy-home-banner]').forEach((banner) => {
      const sidebar = banner.querySelector('.legacy-home-banner__sidebar');
      const bands = Array.from(document.querySelectorAll('.legacy-home-layout-band'));
      const startIndex = bands.indexOf(banner);
      const layoutBands = startIndex >= 0 ? bands.slice(startIndex) : [];
      const lastBand = layoutBands.at(-1);

      if (!lastBand) return;

      lastBand.style.paddingBottom = '';

      if (!sidebar || !window.matchMedia('(min-width: 992px)').matches) return;

      const bannerTop = banner.getBoundingClientRect().top + window.scrollY;
      const contentBottom = Math.max(...layoutBands.map((band) => band.getBoundingClientRect().bottom + window.scrollY));
      const requiredSpace = sidebar.getBoundingClientRect().height - (contentBottom - bannerTop);

      if (requiredSpace > 0) {
        lastBand.style.paddingBottom = `${requiredSpace}px`;
      }
    });
  };

  const scheduleLegacyHomeSidebarSync = () => window.requestAnimationFrame(syncLegacyHomeSidebar);

  window.addEventListener('load', scheduleLegacyHomeSidebarSync);
  window.addEventListener('resize', scheduleLegacyHomeSidebarSync);
  document.addEventListener('shopify:section:load', scheduleLegacyHomeSidebarSync);
  document.addEventListener('shopify:section:reorder', scheduleLegacyHomeSidebarSync);
  scheduleLegacyHomeSidebarSync();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-default"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-default-collection]');
    if (!root) return;

    var sort = root.querySelector('[data-dc-sort]');
    if (sort) sort.addEventListener('change', function () { sort.form.submit(); });

    root.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-dc-add-form]');
      if (!form || !window.cpCart || typeof window.cpCart.addItems !== 'function') return;
      event.preventDefault();
      var button = form.querySelector('[data-dc-add-button]');
      var variant = form.querySelector('[name="id"]');
      if (!variant) return;
      var original = button.textContent;
      button.disabled = true;
      button.textContent = button.dataset.addingLabel;
      window.cpCart.addItems([{ id: Number(variant.value), quantity: 1 }])
        .then(function () {
          button.textContent = button.dataset.addedLabel;
          window.setTimeout(function () { button.textContent = original; button.disabled = false; }, 1400);
        })
        .catch(function () {
          button.textContent = button.dataset.errorLabel;
          window.setTimeout(function () { button.textContent = original; button.disabled = false; }, 1800);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-default"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-default-product]');
    if (!root) return;

    var mainImage = root.querySelector('#DefaultProductImage');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-dp-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dp-dot]'));
    var currentCounter = root.querySelector('[data-dp-current-image]');
    var currentIndex = Math.max(0, thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); }));

    function showImage(index) {
      if (!thumbs.length) return;
      currentIndex = (index + thumbs.length) % thumbs.length;
      var thumb = thumbs[currentIndex];
      if (mainImage && thumb.dataset.image) {
        mainImage.src = thumb.dataset.image;
        mainImage.alt = thumb.dataset.alt || '';
      }
      thumbs.forEach(function (item, itemIndex) {
        var active = itemIndex === currentIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });
      dots.forEach(function (dot, dotIndex) { dot.setAttribute('aria-current', dotIndex === currentIndex ? 'true' : 'false'); });
      if (currentCounter) currentCounter.textContent = String(currentIndex + 1);
    }

    thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { showImage(Number(thumb.dataset.index)); }); });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { showImage(Number(dot.dataset.index)); }); });
    var previous = root.querySelector('[data-dp-gallery-prev]');
    var next = root.querySelector('[data-dp-gallery-next]');
    if (previous) previous.addEventListener('click', function () { showImage(currentIndex - 1); });
    if (next) next.addEventListener('click', function () { showImage(currentIndex + 1); });
    if (thumbs.length) showImage(currentIndex);

    var price = root.querySelector('[data-dp-price]');
    var compare = root.querySelector('[data-dp-compare]');
    var savings = root.querySelector('[data-dp-save]');
    var variantInput = root.querySelector('[data-dp-variant-input]');
    var variantOptions = Array.prototype.slice.call(root.querySelectorAll('[data-dp-variant-option]'));
    var addButton = root.querySelector('#product-add-to-cart');
    var addLabel = root.querySelector('[data-dp-add-label]');
    var cartTotal = root.querySelector('[data-dp-cart-total]');
    var selectedVariantOption = variantOptions.find(function (option) { return option.classList.contains('is-selected'); }) || variantOptions[0];
    var selectedPriceCents = Number(selectedVariantOption ? selectedVariantOption.dataset.priceCents : root.dataset.selectedPriceCents || 0);

    function formatMoney(cents, fallback) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.money_format) return window.Shopify.formatMoney(cents, window.money_format);
      return fallback || '';
    }

    function updateTotal() {
      if (!cartTotal) return;
      var quantityInput = root.querySelector('#DefaultProductQuantity');
      var quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;
      cartTotal.textContent = formatMoney(selectedPriceCents * quantity, price ? price.textContent : '');
    }

    variantOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        var available = option.dataset.available === 'true';
        selectedPriceCents = Number(option.dataset.priceCents || 0);
        variantOptions.forEach(function (item) {
          var selected = item === option;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (variantInput) variantInput.value = option.dataset.variantId;
        if (price) price.textContent = option.dataset.price || '';
        var compareCents = Number(option.dataset.compareCents || 0);
        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.hidden = compareCents <= selectedPriceCents;
        }
        if (savings) {
          if (compareCents > selectedPriceCents) {
            savings.hidden = false;
            savings.textContent = savings.dataset.saveTemplate.replace('__PERCENT__', String(Math.round((compareCents - selectedPriceCents) * 100 / compareCents)));
          } else {
            savings.hidden = true;
          }
        }
        if (mainImage && option.dataset.image) mainImage.src = option.dataset.image;
        if (addButton) addButton.disabled = !available;
        if (addLabel) addLabel.textContent = available ? addLabel.dataset.availableLabel : addLabel.dataset.soldOutLabel;
        updateTotal();
      });
    });

    var quantity = root.querySelector('#DefaultProductQuantity');
    var minus = root.querySelector('[data-dp-quantity-minus]');
    var plus = root.querySelector('[data-dp-quantity-plus]');
    if (quantity && minus && plus) {
      minus.addEventListener('click', function () { quantity.value = Math.max(1, parseInt(quantity.value, 10) - 1 || 1); updateTotal(); });
      plus.addEventListener('click', function () { quantity.value = Math.max(1, parseInt(quantity.value, 10) + 1 || 1); updateTotal(); });
      quantity.addEventListener('change', updateTotal);
    }
    updateTotal();

    var inquiry = document.querySelector('[data-dp-inquiry]');
    if (inquiry) {
      document.addEventListener('click', function (event) {
        if (event.target.closest('[data-dp-inquiry-open]')) {
          inquiry.hidden = false;
          document.body.style.overflow = 'hidden';
        }
        if (event.target.closest('[data-dp-inquiry-close]')) {
          inquiry.hidden = true;
          document.body.style.overflow = '';
        }
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !inquiry.hidden) {
          inquiry.hidden = true;
          document.body.style.overflow = '';
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maxim-landing-reviews"] && !Shopify.designMode) return;
  try {
    
  function openLandingReviews() {
    const section = document.getElementById('customer-reviews');
    const reviews = section && section.querySelector('.slp-all-reviews');
    if (reviews) reviews.open = true;
    return section;
  }

  document.addEventListener('click', function(event) {
    if (event.target.closest('a[href="#customer-reviews"]')) openLandingReviews();
  });

  window.addEventListener('hashchange', function() {
    if (window.location.hash === '#customer-reviews') openLandingReviews();
  });

  if (window.location.hash === '#customer-reviews') {
    const section = openLandingReviews();
    if (section) requestAnimationFrame(function() { section.scrollIntoView(); });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-video-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('play',function(event){
    if (!event.target.matches('.sf-vr-card video')) return;
    event.target.closest('.sf-vr-grid').querySelectorAll('video').forEach(function(video){if(video!==event.target)video.pause();});
  },true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sweat-all-reviews"] && !Shopify.designMode) return;
  try {
    
  function openLandingReviews() {
    const section = document.getElementById('customer-reviews');
    const reviews = section && section.querySelector('.slp-all-reviews');
    if (reviews) reviews.open = true;
    return section;
  }

  document.addEventListener('click', function(event) {
    if (event.target.closest('a[href="#customer-reviews"]')) openLandingReviews();
  });

  window.addEventListener('hashchange', function() {
    if (window.location.hash === '#customer-reviews') openLandingReviews();
  });

  if (window.location.hash === '#customer-reviews') {
    const section = openLandingReviews();
    if (section) requestAnimationFrame(function() { section.scrollIntoView(); });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sweat-videos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('play', function(event) {
    if (!event.target.matches('.slp-video video')) return;
    document.querySelectorAll('.slp-video video').forEach(function(video) { if (video !== event.target) video.pause(); });
  }, true);

  } catch(e) { console.error(e); }
})();
})();
